import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionSummary, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, useMinimalsTheme } from '@tom-ui/ui'
import { JourneyResponse } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

type Props = {
  unallocatedJourneys: JourneyResponse[]
}

export const UnallocatedContainersAccordion = observer((props: Props) => {
  const { unallocatedJourneys } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const [expanded, setExpanded] = useState(false)

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      disableGutters
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{
          display: 'flex',
          backgroundColor: theme.palette.grey[200],
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiAccordionSummary-content': {
            my: 0,
          },
        }}
      >
        <Stack
          sx={{
            width: '100%',
          }}
          direction='row'
          gap={theme.customSpacing.s}
          alignItems='center'
        >
          <Typography variant='subtitle1'>
            {t('unallocatedContainers', 'Unallocated containers')}
          </Typography>
          <ColoredLabel color='primary' label={unallocatedJourneys.length.toString()} />
        </Stack>
      </AccordionSummary>
      <Stack direction='column'>
        {unallocatedJourneys.map(journey => (
          <Stack
            key={journey.id}
            direction='column'
            p={theme.customSpacing.s}
            sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}
          >
            {/* <Stack direction='row' justifyContent='space-between' alignItems='center'>
              <Box>
                <Typography variant='body2' fontSize={'0.7rem'}>
                  {journey.portOfLoading}
                </Typography>
              </Box>
            </Stack> */}
            <Typography variant='subtitle2' fontWeight='bold' lineHeight={1.2} fontSize={`1rem`}>
              {journey.container?.containerNumber}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Accordion>
  )
})
